import { GetDtrScatterPlotInput, ScatterPlot } from '@/models/gen/graphql';

import { GetDtrScatterPlotDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';
import { handleError } from '@/utils/custom';

type GetDtrScatterPlotGraphApiResponse = GraphApiResponse<typeof GetDtrScatterPlotDocument>;

const title = 'Get Drive Time Scatter Plot';

const getDtrScatterPlotResponseSelector = (res: GetDtrScatterPlotGraphApiResponse): ScatterPlot =>
  res?.getDtrScatterPlot?.output as ScatterPlot;

const [_runGetDtrScatterPlot, runRefetchGetDtrScatterPlot] = graphApi(GetDtrScatterPlotDocument, {
  onError: (res: GetDtrScatterPlotGraphApiResponse): void => handleError(res, { notification: { title } }),
});

export const getDtrScatterPlot = async (input: GetDtrScatterPlotInput): Promise<ScatterPlot> => {
  const res = await runRefetchGetDtrScatterPlot({ input });

  return getDtrScatterPlotResponseSelector(res);
};

export const useGetDtrScatterPlot = createGraphApiHook(getDtrScatterPlot);
